// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoGrid_root__1X_1p"};